<template>
    <div class="reservation_items" :class="'reservation_items--count-' + columnCount" v-if="events.length !== 0">
        <reservation-item
            v-for="event in events"
            :key="event.id"
            :event="event.schedule_data"
            :type="event.type"
            :status="event.registration_status"
            @click="this.$router.push({name: 'ReservationSingle', params: {id: event.id}})"
        />
    </div>
    <div class="reservation_items reservation_items--empty" v-if="events.length === 0">
        <i>
            <img src="../assets/img/kek.png">
        </i>
        <p>{{ emptyText }}</p>
    </div>
</template>

<script>
    import ReservationItem from '../components/ReservationItem'

    export default {
        name: "ReservationList",
        components: { ReservationItem },
        props: {
            events: {
                type: Array,
                default: () => []
            },
            columnCount: {
                type: Number,
                default: () => 1
            },
            emptyText: {
                type: String,
                default: () => 'Вы еще никуда не записались'
            }
        },
    }
</script>